import "./Story.scss"
import { Modal } from "../../../components/ui/modal/Modal"
import { useState } from "react"
import { Link } from "react-router-dom"
import { api } from "../../../services/api"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

const ExitButton = () => {
  const { t } = useTranslation()
  return (
    <Link to={"/"}>
      <button className="btn rojo">{t(`games.story.btns.exit`)}</button>
    </Link>
  )
}

const PlayAgainButton = () => {
  const { t } = useTranslation()
  const playAgain = () => {
    window.location.reload(false)
  }
  return (
    <button className="btn verde" onClick={() => playAgain()}>
      {t(`games.story.btns.play_again`)}
    </button>
  )
}

const KeepTryingButton = ({ setShowModal }) => {
  const { t } = useTranslation()
  const keepTrying = () => {
    setShowModal(false)
  }
  return (
    <button className="btn azul" onClick={() => keepTrying()}>
      {t(`games.story.btns.try_again`)}
    </button>
  )
}

const SeeSolutionButton = ({ storyParts, setStoryParts, setShowModal }) => {
  const { t } = useTranslation()
  const orderStoryParts = () => {
    setStoryParts(storyParts.sort((a, b) => (a.order > b.order ? 1 : -1)))
    setShowModal(false)
  }
  return (
    <button className="btn verde" onClick={() => orderStoryParts()}>
      {t(`games.story.btns.show_solution`)}
    </button>
  )
}

const EndGameModal = ({ show, wonGame, storyParts, setStoryParts }) => {
  const { t } = useTranslation()
  return (
    <Modal
      show={show}
      header={
        <center>
          {wonGame
            ? t(`games.story.msgs.you_won`)
            : t(`games.story.msgs.error`)}
        </center>
      }
      footer={
        <div>
          {wonGame ? (
            <PlayAgainButton setShowModal={show[1]} />
          ) : (
            <>
              {" "}
              <KeepTryingButton setShowModal={show[1]} />{" "}
              <SeeSolutionButton
                setShowModal={show[1]}
                storyParts={storyParts}
                setStoryParts={setStoryParts}
              />{" "}
            </>
          )}
          <ExitButton />
        </div>
      }
    />
  )
}

const Instructions = ({ showStory }) => {
  const { t } = useTranslation()
  return (
    <>
      <p className="text">
        {showStory
          ? t(`games.story.instructions_start`)
          : t(`games.story.instructions_play`)}
      </p>
    </>
  )
}

export const StoryParts = ({ storyParts, setStoryParts }) => {
  const [draggingPart, setDraggingPart] = useState()
  const [draggingOver, setDraggingOver] = useState()

  const onDrop = (droppedAtOrder) => {
    const originIndex = storyParts.findIndex(
      (part) => part.order === draggingPart
    )
    const targetIndex = storyParts.findIndex(
      (part) => part.order === droppedAtOrder
    )
    setStoryParts(
      storyParts.map((part) => {
        if (part.order === draggingPart) {
          return storyParts[targetIndex]
        } else if (part.order === droppedAtOrder) {
          return storyParts[originIndex]
        } else {
          return part
        }
      })
    )
    setDraggingPart()
    setDraggingOver()
  }

  return (
    <>
      {storyParts.map((part, i) => (
        <StoryPart
          key={part.order}
          part={part}
          draggingPart={draggingPart}
          setDraggingPart={setDraggingPart}
          onDrop={onDrop}
          draggingOver={draggingOver}
          setDraggingOver={setDraggingOver}
        />
      ))}
    </>
  )
}

const StoryPart = ({
  part,
  draggingPart,
  setDraggingPart,
  onDrop,
  draggingOver,
  setDraggingOver,
}) => {
  const onDragStart = () => {
    setDraggingPart(part.order)
  }

  const onDragOver = (e) => {
    e.preventDefault()
    setDraggingOver(part.order)
  }

  return (
    <div
      draggable
      className={
        draggingOver === part.order && part.order !== draggingPart
          ? "story-part dragging-over text"
          : "story-part text"
      }
      onDragStart={() => onDragStart()}
      onDragOver={(e) => onDragOver(e)}
      onDrop={() => onDrop(part.order)}>
      {part.text}
    </div>
  )
}

const GameContent = ({
  title,
  story,
  storyParts,
  setStoryParts,
  showStory,
}) => {
  return (
    <section className="box" style={{ margin: "0px auto" }}>
      <h1 className="title">{title}</h1>
      {showStory ? (
        <StoryText story={story} />
      ) : (
        <StoryParts storyParts={storyParts} setStoryParts={setStoryParts} />
      )}
    </section>
  )
}

const StoryText = ({ story }) => {
  return (
    <div className="text" style={{ wordWrap: "break-word" }}>
      {story}
    </div>
  )
}

const Navigation = ({ showStory, setShowStory, onEndGame }) => {
  const { t } = useTranslation()
  return (
    <div
      className="navigation w-100 mt-4"
      style={{ display: "flex", justifyContent: "center" }}>
      <button
        onClick={() => setShowStory(!showStory)}
        className={showStory ? "btn azul" : "btn blanco"}>
        {showStory ? t(`games.story.btns.next`) : t(`games.story.btns.back`)}
      </button>
      {!showStory ? (
        <button className="btn verde" onClick={() => onEndGame()}>
          {t(`games.story.btns.done`)}
        </button>
      ) : (
        ""
      )}
    </div>
  )
}

const Story = ({ chosenStory }) => {
  const [data, setData] = useState([])
  const [showStory, setShowStory] = useState(true)
  const [storyParts, setStoryParts] = useState([])
  const [showEndModal, setShowEndModal] = useState(false)
  const [wonGame, setWonGame] = useState(false)

  useEffect(() => {
    const { url, opt } = api.games.Story.Generate({ id: chosenStory })
    fetch(url, opt)
      .then((res) => res.json())
      .then((d) => {
        setData(d)
        setStoryParts(d.fragments)
      })
    // eslint-disable-next-line
  }, [])

  const onEndGame = () => {
    const [won] = storyParts.reduce(
      (prev, current) => [prev[0] && prev[1] < current.order, current.order],
      [true, 0]
    )
    setWonGame(won)
    setShowEndModal(true)
  }

  return (
    <>
      <div className="container">
        <Instructions showStory={showStory} />
      </div>
      {data && storyParts && (
        <>
          <div className="container">
            <GameContent
              title={data.title}
              story={data.story}
              showStory={showStory}
              storyParts={storyParts}
              setStoryParts={setStoryParts}
            />
          </div>
          <div className="container">
            <Navigation
              showStory={showStory}
              setShowStory={setShowStory}
              onEndGame={onEndGame}
            />
          </div>
          <EndGameModal
            show={[showEndModal, setShowEndModal]}
            storyParts={storyParts}
            setStoryParts={setStoryParts}
            wonGame={wonGame}
          />
        </>
      )}
    </>
  )
}

export default Story
